import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["popover"]

  connect() {
    this.onOutsideClick = this.handleOutsideClick.bind(this)
    this.onKeydown = this.handleKeydown.bind(this)
    this.element.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.onKeydown)
    document.removeEventListener("click", this.onOutsideClick)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const isOpen = this.popoverTarget.classList.contains("is-open")

    document.querySelectorAll(".col-filter-popover.is-open").forEach((element) => {
      element.classList.remove("is-open")
      element.closest("[data-controller~='filter-popover']")?.querySelector(".col-filter-btn")?.setAttribute("aria-expanded", "false")
    })
    document.removeEventListener("click", this.onOutsideClick)

    if (!isOpen) {
      this.popoverTarget.classList.add("is-open")
      event.currentTarget.setAttribute("aria-expanded", "true")
      this.positionPopover(event.currentTarget)

      requestAnimationFrame(() => {
        this.firstInput()?.focus()
      })

      document.addEventListener("click", this.onOutsideClick)
    }
  }

  apply(event) {
    if (event) event.preventDefault()
    this.submitForm()
  }

  clear(event) {
    event.preventDefault()

    this.filterFields().forEach((input) => {
      if (input._flatpickr) {
        input._flatpickr.clear()
      } else if (input.tagName === "SELECT") {
        input.selectedIndex = 0
      } else {
        input.value = ""
      }
    })

    this.submitForm()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
      return
    }

    if (event.key === "Enter") {
      const tagName = event.target.tagName
      if (tagName === "INPUT") {
        event.preventDefault()
        this.submitForm()
      }
    }
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  close() {
    this.popoverTarget.classList.remove("is-open")
    this.element.querySelector(".col-filter-btn")?.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this.onOutsideClick)
  }

  submitForm() {
    const form = this.element.closest("form")
    if (!form) return

    this.removeBlankInputsBeforeSubmit(form)
    form.requestSubmit()
  }

  removeBlankInputsBeforeSubmit(form) {
    form.querySelectorAll("[data-filter-field]").forEach((input) => {
      if (input.value === "") {
        input.disabled = true
      } else {
        input.disabled = false
      }
    })
  }

  filterFields() {
    return this.popoverTarget.querySelectorAll("[data-filter-field]")
  }

  firstInput() {
    return this.popoverTarget.querySelector("input, select, textarea")
  }

  positionPopover(button) {
    const rect = button.getBoundingClientRect()
    const popover = this.popoverTarget
    const gap = 6

    let top = rect.bottom + gap
    let left = rect.left

    const popoverWidth = popover.offsetWidth || 220
    const popoverHeight = popover.offsetHeight
    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    if (top + popoverHeight > viewportHeight - 8) {
      top = Math.max(8, rect.top - popoverHeight - gap)
    }

    if (left + popoverWidth > viewportWidth - 8) {
      left = viewportWidth - popoverWidth - 8
    }

    if (left < 8) {
      left = 8
    }

    popover.style.top = `${top}px`
    popover.style.left = `${left}px`
  }
}
